import { Component, OnInit } from '@angular/core';
import { UserService } from '../../services/user.service';
import { Router, ActivatedRoute, Params } from '@angular/router';
import {FormBuilder, FormGroup, Validators, FormControl, FormArray} from '@angular/forms';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import {AlertPopComponent} from '../alert-pop/alert-pop.component';
import { ConfirmPopComponent } from '../confirm-pop/confirm-pop.component';
import { MesaDeAyudaService } from '../../services/mesa-de-ayuda.service';

@Component({
  selector: 'app-crear-ticket',
  templateUrl: './crear-ticket.component.html',
  styleUrls: ['./crear-ticket.component.css'],
  providers: [UserService, MesaDeAyudaService]
})
export class CrearTicketComponent implements OnInit {
  public sessionActive: boolean;
  public message: string;
  public status: string;
  form: FormGroup;
  filesEvidencia: FormArray;
  filesReference = [];
  tiposSoporte = [];
  upaegsMine = [];
  recomendaciones = [];

  constructor(
    public dialog: MatDialog,
    private route: ActivatedRoute,
    private router: Router,
    private userService: UserService,
    private mesaDeAyudaService: MesaDeAyudaService,
    private fb: FormBuilder
  ) {
    this.form = this.fb.group({
      idTipoTicket: ['', [Validators.required]],
      idUpaegRelacionada: ['', [Validators.required]],
      asunto: ['', [Validators.required]],
      modulo: ['registroenlinea', [Validators.required]],
      descripcion: ['', [Validators.required]],
      documentosEvidencia: this.fb.array([]),
    });
  }

  ngOnInit() {
    /* VALIDATE SESSION */
    if (this.userService.getToken()){
      this.userService.check_session().subscribe(response => {
        if (response.status) {
        } else {
          this.userService.destroy_session();
          this.router.navigate(['/login']);
        }
      }, error => {
        console.log(error);
        this.userService.destroy_session();
        this.router.navigate(['/login']);
      });
    }else{
      this.userService.destroy_session();
      this.router.navigate(['/login']);
    }
   /* VALIDATE SESSION */
    this.getTiposTicket();
    this.getMisUpaegs();
  }

  openDialog(title, text, action): void {
    const dialogRef = this.dialog.open(AlertPopComponent, {
      width: '40%',
      data: {
        titulo: title,
        texto: text,
        confirm: action
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log(result);
    });
  }

  fileChangeEvent(event){
    // console.log(event);
    if (event.target.files.length > 0) {
      let file = event.target.files[0];
      // console.log(file);
      this.filesEvidencia = this.form.get('documentosEvidencia') as FormArray;
      this.filesEvidencia.push(this.addFileItem(file));
      // console.log(this.form.value);
      this.filesReference.push(file);
      // this.form.get('documentosEvidencia').setValue(file);
      // console.log(this.form.get('documentosEvidencia').value);
    }
    event.target.value = null;
  }

  addFileItem(value){
    return this.fb.group({
      archivo: [value,[]],
    });
  }

  getTiposTicket() {
    this.mesaDeAyudaService.getTiposTicket().subscribe(response => {
      console.log(response);
      this.tiposSoporte = response;
    }, error => {
      console.log(error);
      this.tiposSoporte = [];
    });
  }

  getMisUpaegs() {
    this.mesaDeAyudaService.getMisUpaegsCombo().subscribe(response => {
      console.log(response);
      if(response.status){
        this.upaegsMine  = response.upaegs;
      } else {
        this.upaegsMine  = [];
      }
    }, error => {
      console.log(error);
      this.upaegsMine = [];
    });
  }

  removeDocto(indice){
    console.log(indice);
    this.filesEvidencia = this.form.get('documentosEvidencia') as FormArray;
    this.filesEvidencia.removeAt(indice);
    console.log(this.form.value);
    this.filesReference.splice(indice, 1);
  }

  private prepareSave(): any{
    let formu = new FormData();
    formu.append('idTipoTicket', this.form.get('idTipoTicket').value);
    formu.append('idUpaegRelacionada', this.form.get('idUpaegRelacionada').value);
    formu.append('asunto', this.form.get('asunto').value);
    formu.append('descripcion', this.form.get('descripcion').value);
    formu.append('modulo', this.form.get('modulo').value);
    let files = this.form.get('documentosEvidencia').value;
    console.log('Archivos');
    console.log(files);
    console.log('Archivos');
    files.forEach((archivo, key) => {
      /*console.log('Llave'+key);
      console.log(archivo);
      console.log(archivo.archivo);*/
      formu.append('documentosEvidencia[' + key + ']', archivo.archivo);
      // formu.append('documentosEvidencia['+key+']', archivo.value);
    });
    // formu.append('documentosEvidencia', this.form.get('documentosEvidencia').value);
    return formu;
  }

  alertDialog(title, text, action): void {
    const dialogRef = this.dialog.open(AlertPopComponent, {
      width: '40%',
      data: {
        titulo: title,
        texto: text,
        confirm: action
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log(result);
    });
  }

  onSubmit(saveTicket) {
    const formData = this.prepareSave();
    this.mesaDeAyudaService.saveTicket(formData).subscribe(response => {
      console.log(response);
      if (response.status) {
        this.alertDialog('Guardado', response.message, 'Cerrar');
        this.router.navigate(['/mesadeayuda']);
      } else {
        this.alertDialog('Error', response.message, 'Cerrar');
      }
    }, error => {
      console.log(error);
      this.alertDialog('Error', 'No se puede procesar su petición en este momento', 'Cerrar');
    });
  }


  onSelectTipoAsistencia(): void{
    const tipoAsistencia = this.form.get('idTipoTicket').value;
    if (tipoAsistencia !== '' && tipoAsistencia != null) {
      this.mesaDeAyudaService.getDocumentosForTipoTicket(tipoAsistencia).subscribe(response => {
        console.log(response);
        if (response.status) {
          this.recomendaciones = response.recomendaciones;
        } else {
          this.alertDialog('Error', response.message, 'Cerrar');
        }

      }, error => {
        console.log(error);
        this.alertDialog('Error', 'No se puede procesar su petición en este momento', 'Cerrar');
      });

    } else {
      this.recomendaciones = [];
    }

  }

}
